import React, { useCallback, useRef } from "react";
import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { useParams } from "react-router-dom";
import { CustomData } from "../../Models/CustomData";
import { CustomDataListItem } from "./CustomDataListItem";
import { useListProps } from "./utilities/list";
import { CustomDataHeader } from "./CustomDataHeader";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const CustomDataIndex: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const { id } = useParams<{ id: string }>();
  const listProps = useListProps(id);

  const renderHeader = useCallback(() => {
    return <CustomDataHeader />;
  }, []);

  const renderItem = useCallback((item: CustomData, index: number) => {
    return <CustomDataListItem listRef={listRef} item={item} index={index} />;
  }, []);

  return (
    <>
      <AnyListProvider path={listProps.path} filters={listProps.filters}>
        <AnyList
          renderItem={renderItem}
          pagination={listProps.pagination}
          actionBar={listProps.actionBar}
          selectRowsEnabled={listProps.selectRowsEnabled}
          renderHeader={renderHeader}
        />
      </AnyListProvider>
    </>
  );
};
